module.exports = __webpack_public_path__ + "static/media/home4.a39c5d5a.jpg";